/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetSlackIdentityMappingRequestBody,
  SetSlackIdentityMappingRequestBody$Outbound,
  SetSlackIdentityMappingRequestBody$outboundSchema,
} from "../components/setslackidentitymappingrequestbody.js";

export type SetSlackIdentityMappingSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetSlackIdentityMappingRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setSlackIdentityMappingRequestBody: SetSlackIdentityMappingRequestBody;
};

/** @internal */
export type SetSlackIdentityMappingSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetSlackIdentityMappingSecurity$outboundSchema: z.ZodMiniType<
  SetSlackIdentityMappingSecurity$Outbound,
  SetSlackIdentityMappingSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setSlackIdentityMappingSecurityToJSON(
  setSlackIdentityMappingSecurity: SetSlackIdentityMappingSecurity,
): string {
  return JSON.stringify(
    SetSlackIdentityMappingSecurity$outboundSchema.parse(
      setSlackIdentityMappingSecurity,
    ),
  );
}

/** @internal */
export type SetSlackIdentityMappingRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetSlackIdentityMappingRequestBody:
    SetSlackIdentityMappingRequestBody$Outbound;
};

/** @internal */
export const SetSlackIdentityMappingRequest$outboundSchema: z.ZodMiniType<
  SetSlackIdentityMappingRequest$Outbound,
  SetSlackIdentityMappingRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    setSlackIdentityMappingRequestBody:
      SetSlackIdentityMappingRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      setSlackIdentityMappingRequestBody: "SetSlackIdentityMappingRequestBody",
    });
  }),
);

export function setSlackIdentityMappingRequestToJSON(
  setSlackIdentityMappingRequest: SetSlackIdentityMappingRequest,
): string {
  return JSON.stringify(
    SetSlackIdentityMappingRequest$outboundSchema.parse(
      setSlackIdentityMappingRequest,
    ),
  );
}
